import { successStories, testimonials } from '../data/siteData';
import { PageHero, CTASection, TestiCard } from '../components/UI';

export default function Stories({ setPage }) {
  return (
    <div>
      <PageHero
        breadcrumb="Success Stories"
        title="Real People. Real Journeys."
        subtitle="Behind every visa approval and university admission is a story of ambition, hard work, and the right support at the right time."
      />

      {/* Featured Stories */}
      <section className="py-24 bg-cream">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-14">
            <span className="section-tag">Featured Journeys</span>
            <h2 className="font-display text-4xl text-navy font-semibold mt-1">In Their Own Words</h2>
          </div>

          <div className="flex flex-col gap-8">
            {successStories.map((s, i) => (
              <div key={s.name} className="bg-white rounded-3xl p-8 sm:p-10 shadow-card hover:shadow-card-hover transition-all duration-300">
                <div className="flex flex-col sm:flex-row gap-6 items-start">
                  {/* Avatar */}
                  <div className="flex flex-col items-center gap-2 flex-shrink-0">
                    <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${s.color} flex items-center justify-center font-bold text-2xl text-white`}>{s.initial}</div>
                    <span className="text-2xl">{s.flag}</span>
                  </div>
                  {/* Content */}
                  <div className="flex-1">
                    <h4 className="font-body font-semibold text-navy text-lg mb-1">{s.name}</h4>
                    <p className="text-xs text-gray-400 mb-5">{s.role}</p>
                    <div className="text-teal text-3xl font-serif leading-none mb-3">"</div>
                    <p className="text-gray-600 text-sm leading-relaxed italic mb-6">{s.text}</p>
                    <div className="flex flex-wrap gap-2">
                      {s.tags.map(tag => (
                        <span key={tag} className="text-xs font-semibold text-teal bg-teal/8 px-3 py-1 rounded-full tracking-wide uppercase">{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Banner */}
      <section className="py-16 bg-gradient-to-br from-teal to-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 text-center">
            {[
              { n: '3,000+', l: 'Students Placed' },
              { n: '95%+', l: 'Visa Success Rate' },
              { n: '7+', l: 'Destination Countries' },
              { n: '50+', l: 'Partner Universities' },
            ].map(({ n, l }) => (
              <div key={l}>
                <div className="font-display text-5xl font-semibold text-white mb-2">{n}</div>
                <div className="text-white/55 text-sm">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* All Testimonials */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-14">
            <span className="section-tag">More Reviews</span>
            <h2 className="font-display text-4xl text-navy font-semibold mt-1">What Our Clients Say</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map(t => <TestiCard key={t.name} {...t} />)}
          </div>
        </div>
      </section>

      <CTASection
        title="Ready to Write Your Own Success Story?"
        subtitle="Join thousands of students and professionals who trusted Travizon — and never looked back."
        setPage={setPage}
      />
    </div>
  );
}
